import { Box, Container, Stack, Typography, Paper, useMediaQuery ,List, ListItem, ListItemIcon, ListItemText, Link } from '@mui/material';
import { motion } from 'framer-motion';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CodeIcon from '@mui/icons-material/Code';
import rocket from '../assets/img/image.jpg';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const events = [
  { date: 'Nov-6',     label: 'Registration starts',       dotColor: 'warning' },
  { date: 'Nov-13',    label: 'Registration Ends',         dotColor: 'error'   },
  { date: 'Nov-21',    label: 'Deadline for Project Title submission',             dotColor: 'warning' },
  // { date: 'Feb-15',    label: 'Final Review',              dotColor: 'error'   },
  // { date: 'Feb-22',    label: 'Demo Day',                  dotColor: 'success' },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.3 },
  },
};

const cardVariants = {
  hidden: { y: 60, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 12 } },
};

const titleVariants = {
  hidden: { y: -50, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.6, type: 'spring', stiffness: 120 } },
};

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.25, delayChildren: 0.2 },
  },
};

const item = {
  hidden: { opacity: 0, x: -60 },
  visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 120 } },
};

const dot = {
  hidden: { scale: 0 },
  visible: { scale: 1, transition: { type: 'spring', stiffness: 300, delay: 0.3 } },
};

const dotBg = (color) => {
  const map = {
    warning: '#FFB800',
    error:   '#F44336',
    success: '#4CAF50',
  };
  return map[color] || '#888';
};

const itemVariants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0 },
};

const BulletPoint = ({ children }) => (
  <Stack direction="row" spacing={2} alignItems="flex-start" sx={{ mb: 2 }}>
    <Box
      sx={{
        width: 12,
        height: 12,
        borderRadius: '50%',
        bgcolor: '#FF6B35',
        flexShrink: 0,
        mt: 0.8,
      }}
    />
    <Typography variant="body1" sx={{ flex: 1, lineHeight: 1.6 }}>
      {children}
    </Typography>
  </Stack>
);

const MoneyBag = ({ amount, color }) => (
  <Box sx={{ position: 'relative', textAlign: 'center' }}>
    <svg width="60" height="70" viewBox="0 0 60 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30 10C20 10 15 15 15 20V50C15 58 20 65 30 65C40 65 45 58 45 50V20C45 15 40 10 30 10Z" fill={color} />
      <path d="M22.5 20H37.5V25C37.5 27 36 28 34 28H26C24 28 22.5 27 22.5 25V20Z" fill="#FFF" opacity="0.9" />
      <text x="30" y="58" fill="white" fontSize="16" fontWeight="bold" textAnchor="middle">₹</text>
    </svg>
    <Typography variant="h6" sx={{ mt: 1, fontWeight: 'bold', color: '#FF6B35' }}>
      {amount}
    </Typography>
  </Box>
);


export default function ContestTimeline() {
    const ismobile = useMediaQuery("(max-width:735px)");
const RocketImage = () => (
  <motion.div
    initial={{ y: 100, rotate: 5, opacity: 0 }}
    animate={{ y: 0, rotate: 0, opacity: 1 }}
    transition={{
      type: 'spring',
      stiffness: 80,
      damping: 15,
      duration: 1.2,
      delay: 0.5,
    }}
    style={{
      width: '100%',
      // maxWidth: 220,
      height: 'auto',
      display:'flex',
      alignItems:'center',
      justifyContent:'center'
    }}
  >
    <Box
      component="img"
      src={rocket} // Change this path if needed
      alt="Rocket launching"
      sx={{
        width: ismobile?'80%':'100%',
        height: ismobile?'40vh':'80vh',
        borderRadius: 5,
        // boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
        // filter: 'drop-shadow(0 10px 20px rgba(255,107,53,0.2))',
        transition: 'all 0.3s ease',
        '&:hover': {
          transform: 'translateY(-8px)',
          // filter: 'drop-shadow(0 15px 30px rgba(255,107,53,0.3))',
          
        },
      }}
    />
  </motion.div>
);

  return (
    <>
      {/* === GET STARTED SECTION === */}
      <Box sx={{ bgcolor: '#fff', py: { xs: 6, md: 12 }, position: 'relative', overflow: 'hidden' }}>
        <Container maxWidth="lg">
          <motion.div variants={titleVariants} initial="hidden" animate="visible">
            <Typography
              variant="h3"
              align="center"
              sx={{
                fontWeight: 800,
                mb: { xs: 4, md: 6 },
                color: '#000',
                fontSize: { xs: '2.2rem', md: '3.5rem' },
                lineHeight: 1.2,
              }}
            >
              How do I get started?
            </Typography>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" animate="visible">
            <Stack
              direction={{ xs: 'column', md: 'row' }}
              spacing={3}
              alignItems={{ xs: 'center', md: 'flex-start' }}
              justifyContent="center"
            >
              {/* Left: Rocket Image */}
              <Box
                sx={{
                  flex: { xs: 'none', md: 1 },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: { md: 400 },
                }}
              >
                <RocketImage />
              </Box>

              {/* Right: Cards */}
              <Box sx={{ flex: { xs: 1, md: 2 }, minWidth: 0 }}>
                <Stack spacing={3}>
                  <motion.div variants={cardVariants}>
                    <Paper elevation={3} sx={{ p: { xs: 2.5, md: 3.5 }, bgcolor: '#2196F3', color: 'white', borderRadius: 3, minHeight: 80, '&:hover': { transform: 'translateY(-4px)', boxShadow: 8, bgcolor: '#1976D2' } }}>
                      <Typography variant="body1">1. Signup in Thiran through this website and create user Accounts.</Typography>
                    </Paper>
                  </motion.div>

                  <motion.div variants={cardVariants}>
                    <Paper elevation={3} sx={{ p: { xs: 2.5, md: 3.5 }, bgcolor: '#FF5722', color: 'white', borderRadius: 3, minHeight: 100, '&:hover': { transform: 'translateY(-4px)', boxShadow: 8, bgcolor: '#E64A19' } }}>
                      <Typography variant="body1">2. Login using your credentials.</Typography>
                    </Paper>
                  </motion.div>

                  <motion.div variants={cardVariants}>
                    <Paper elevation={3} sx={{ p: { xs: 2.5, md: 3.5 }, bgcolor: '#2196F3', color: 'white', borderRadius: 3, minHeight: 100, '&:hover': { transform: 'translateY(-4px)', boxShadow: 8, bgcolor: '#1976D2' } }}>
                      <Typography variant="body1">3. After Login Goto register page and regsiter with your teammates</Typography>
                    </Paper>
                  </motion.div>

                  <motion.div variants={cardVariants}>
                    <Paper elevation={3} sx={{ p: { xs: 2.5, md: 3.5 }, bgcolor: '#FF5722', color: 'white', borderRadius: 3, minHeight: 80, '&:hover': { transform: 'translateY(-4px)', boxShadow: 8, bgcolor: '#E64A19' } }}>
                      <Typography variant="body1">4. After successfully registering your project, ask your teammates to accept the team invitation by logging into their accounts and accepting the invitation.</Typography>
                    </Paper>
                  </motion.div>
                </Stack>
              </Box>
            </Stack>
          </motion.div>
        </Container>
      </Box>

      {/* === RULES SECTION === */}
      <Box sx={{ bgcolor: '#fff', py: { xs: 6, md: 10 } }}>
        <Container maxWidth="lg">
          <motion.div initial={{ opacity: 0, y: -30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <Typography variant="h3" align="center" sx={{ fontWeight: 800, mb: { xs: 6, md: 8 }, color: '#000', fontSize: { xs: '2.2rem', md: '3rem' } }}>
              Rules
            </Typography>
          </motion.div>

          <motion.div variants={containerVariants} initial="hidden" animate="visible">
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 4, md: 6 }} justifyContent="center">
              <motion.div variants={cardVariants} sx={{ flex: 1, maxWidth: { md: '50%' } }}>
                <Paper elevation={4} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, bgcolor: '#FFF8E1', minHeight: 380, '&:hover': { transform: 'translateY(-8px)', boxShadow: 8 } }}>
                  <Stack spacing={3}>
                    <Box sx={{ textAlign: 'center', mb: 1 }}>
                      <CodeIcon sx={{ fontSize: 48, color: '#FF6B35', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))' }} />
                    </Box>
                    {/* <Typography variant="h5" sx={{ fontWeight: 700, color: '#FF6B35', textAlign: 'center' }}>App Criteria</Typography> */}
                    <Stack sx={{ mt: 2 }}>
                      <motion.div variants={itemVariants}><BulletPoint>Each team must consist  a maximum of 4 undergraduate college students</BulletPoint></motion.div>
                      <motion.div variants={itemVariants}><BulletPoint>
Teams are encouraged to be interdisciplinary.
</BulletPoint></motion.div>
                      <motion.div variants={itemVariants}><BulletPoint>
The project can be from any stream of engineering.
                      </BulletPoint></motion.div>
                                            <motion.div variants={itemVariants}><BulletPoint>
The project must be the team's original work
                      </BulletPoint></motion.div>
                    </Stack>
                  </Stack>
                </Paper>
              </motion.div>
            </Stack>
          </motion.div>
        </Container>
      </Box>

      {/* === PRIZES SECTION === */}
      <Box sx={{ bgcolor: '#fff', py: { xs: 6, md: 10, } }}>
        <Container maxWidth="lg">
          <motion.div variants={containerVariants} initial="hidden" animate="visible">
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 4, md: 6 }} alignItems="center" justifyContent="space-between" gap={ismobile?"30px":"0px"}>
              <Box sx={{ flex: 1, maxWidth: { xs: '100%', md: '45%' } }}>
                <motion.div variants={itemVariants}>
                  <Typography variant="h3" sx={{ fontWeight: 800, color: '#000', mb: 2, fontSize: { xs: '2.2rem', md: '3rem' } }}>
                    What&apos;s in it for you?
                  </Typography>
                </motion.div>
              </Box>

              <Box sx={{ flex: 1, width: '100%'}}>
                <Stack spacing={4} alignItems="center">
                  <motion.div variants={itemVariants}>
                    <Stack direction="row" justifyContent="center" alignItems="flex-end" spacing={{ xs: 1, md: 2 }} sx={{ height: { xs: 180, md: 220 } }}>
                      <Box sx={{ textAlign: 'center' }}><MoneyBag amount="₹3000" color="#9E9E9E" /><Box sx={{ bgcolor: '#B0BEC5', color: '#fff', width: { xs: 70, md: 90 }, height: { xs: 100, md: 130 }, borderRadius: 1, fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' }, boxShadow: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>2</Box></Box>
                      <Box sx={{ textAlign: 'center' }}><MoneyBag amount="₹5000" color="#FFD700" /><Box sx={{ bgcolor: '#3F51B5', color: '#fff', width: { xs: 80, md: 100 }, height: { xs: 140, md: 180 }, borderRadius: 1, fontWeight: 'bold', fontSize: { xs: '2rem', md: '2.5rem' }, boxShadow: 5, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>1</Box></Box>
                      <Box sx={{ textAlign: 'center' }}><MoneyBag amount="₹2000" color="#CD7F32" /><Box sx={{ bgcolor: '#90A4AE', color: '#fff', width: { xs: 70, md: 90 }, height: { xs: 80, md: 100 }, borderRadius: 1, fontWeight: 'bold', fontSize: { xs: '1.5rem', md: '2rem' }, boxShadow: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>3</Box></Box>
                    </Stack>
                  </motion.div>

                  <motion.div variants={itemVariants}>
                    <Paper elevation={3} sx={{ bgcolor: '#E3F2FD', p: { xs: 2, md: 3 }, borderRadius: 3, textAlign: 'center', maxWidth: 400, mx: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5 }}>
                      <EmojiEventsIcon sx={{ fontSize: { xs: 32, md: 40 }, color: '#FFD700' }} />
                      <Typography variant="body1" sx={{ fontWeight: 600, color: '#1565C0' }}>And One Jury Award <strong>₹10000</strong></Typography>
                    </Paper>
                  </motion.div>
                </Stack>
              </Box>
            </Stack>
          </motion.div>
        </Container>
      </Box>

      {/* === TIMELINE SECTION === 
      <Box
      sx={{
        bgcolor: '#FFF8E1',
        minHeight: '100vh',
        py: { xs: 6, md: 10 },
        color: 'black',
        m:5,
        borderRadius:5,
      }}
    >
      <Container maxWidth="lg">
       
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Typography
            variant="h3"
            component="h1"
            align="center"
            sx={{ fontWeight: 700, mb: { xs: 6, md: 8 } }}
          >
            THIRAN Timeline
          </Typography>
        </motion.div>

        // {/* Timeline 
        <motion.div variants={container} initial="hidden" animate="visible">
          <Stack spacing={{ xs: 6, md: 8 }} alignItems="center">
            {events.map((ev, idx) => {
              const isEven = idx % 2 === 0;

              return (
                <motion.div
                  key={idx}
                  variants={item}
                  style={{ width: '100%', maxWidth: 800 }}
                >
                  Mobile – always stacked
                  <Stack
                    direction={{ xs: 'column', md: isEven ? 'row-reverse' : 'row' }}
                    spacing={3}
                    alignItems="center"
                    sx={{ position: 'relative' }}
                  >
                    ---------- DOT + LINE ----------
                    <Box sx={{ position: 'relative', zIndex: 1 }}>
                      <motion.div variants={dot}>
                        <Box
                          sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            bgcolor: dotBg(ev.dotColor),
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 700,
                            fontSize: '1rem',
                            color: '#fff',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                          }}
                        >
                          {ev.date.split(' ')[0]}
                        </Box>
                      </motion.div>

                      {/* Vertical line – hidden on last item 
                      {idx < events.length - 1 && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 56,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 3,
                            height: { xs: 60, md: 80 },
                            bgcolor: 'grey.600',
                            display: { xs: 'none', md: 'block' },
                          }}
                        />
                      )}
                    </Box>

                    ---------- CARD ----------
                    <Box
                      sx={{
                        flex: 1,
                        maxWidth: { xs: '100%', md: 340 },
                        // bgcolor: 'linear-gradient(45deg, #FF6B35, #F7931E)',
                        bgcolor:'#0797F3',
                        color: '#fff',
                        p: { xs: 2, md: 2.5 },
                        borderRadius: 2,
                        textAlign: 'center',
                        boxShadow: '0 4px 15px rgba(255,107,53,0.4)',
                        transition: 'transform 0.2s',
                        '&:hover': {
                          transform: 'translateY(-4px)',
                        },
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold">
                        {ev.label}
                      </Typography>
                      {/* Show the second part of the date only on desktop (e.g. "13‑14") 
                      {ev.date.includes('-') && (
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: 'none', md: 'block' },
                            mt: 0.5,
                            opacity: 0.9,
                          }}
                        >
                          {ev.date.split(' ')[1]}
                        </Typography>
                      )}
                    </Box>

                    {/* Spacer for the zig‑zag layout *
                    <Box sx={{ flex: 1, display: { xs: 'none', md: 'block' } }} />
                  </Stack>
                </motion.div>
              );
            })}
          </Stack>
        </motion.div>
      </Container>
    </Box>*/}
     <Box
      sx={{
        bgcolor: '#0797F3', // Deep teal background
        color: 'white',
        py: { xs: 6, md: 8 },
        borderRadius: { xs: 4, md: 6 },
        mx: { xs: 2, md: 4 },
        my: { xs: 4, md: 6 },
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="md">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {/* Title */}
          <Typography
            variant="h5"
            align="center"
            sx={{
              fontWeight: 700,
              mb: 3,
              fontSize: { xs: '1.5rem', md: '1.8rem' },
              letterSpacing: '0.5px',
            }}
          >
            Get in Touch with Thiran
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            align="center"
            sx={{
              mb: 4,
              lineHeight: 1.7,
              fontSize: { xs: '0.95rem', md: '1.1rem' },
              maxWidth: 700,
              mx: 'auto',
            }}
          >
            We&apos;d love to hear from you! Whether you have questions, want to collaborate, or seek mentorship, 
            feel free to reach out to us. Here&apos;s how you can connect:
          </Typography>

          {/* Contact List */}
          <List sx={{ maxWidth: 600, mx: 'auto' }}>
            {[
              {
                icon: <EmailIcon />,
                text: 'thiran.acgcet@gmail.com',
                href:'#',
              },
              {
                icon: <PhoneIcon />,
                text: '+91 7358010061',
                href: '#',
              },
              {
                icon: <LocationOnIcon />,
                text: 'Thiran – ACGCET | Alagappa Chettiar Government College of Engineering and Technology | Karaikudi, Tamil Nadu, India',
                href: 'https://maps.google.com/?q=Alagappa+Chettiar+Government+College+of+Engineering+and+Technology+Karaikudi',
              },
            ].map((item, index) => (
              <motion.div
                key={index}
                variants={itemVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
              >
                <ListItem
                  sx={{
                    px: 0,
                    py: 1.5,
                    borderRadius: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      transform: 'translateX(4px)',
                    },
                  }}
                >
                  <ListItemIcon sx={{ color: '#B2DFDB', minWidth: 40 }}>
                    {item.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Link
                        href={item.href}
                        underline="hover"
                        target={item.href.startsWith('http') ? '_blank' : undefined}
                        rel={item.href.startsWith('http') ? 'noopener' : undefined}
                        sx={{
                          color: 'white',
                          fontWeight: 500,
                          fontSize: { xs: '0.95rem', md: '1rem' },
                          wordBreak: 'break-word',
                          '&:hover': { color: '#B2DFDB' },
                        }}
                      >
                        {item.text}
                      </Link>
                    }
                  />
                </ListItem>
              </motion.div>
            ))}
          </List>
        </motion.div>
      </Container>
    </Box>
    </>
  );
}